import React, { useCallback, useMemo } from "react";
import styles from "./Style.module.css";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import useProductRewardTable from "./ProductRewardTable.hook";
import classNames from "classnames";
import capitalizeFirstLetter from "../../../../../hooks/CommonFunction";
import { removeUnderScore } from "../../../../../helper/Helper";
import { Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { ArrowPrimaryButton } from "../../../../../components/Buttons/PrimaryButton";
import ProductRewardCreate from "../ProductRewardCreate/ProductRewardCreate";
import { ListActionComponent } from "../../../../../components/CustomListHeader/CustomListHeader";
import useRoles from "../../../../../hooks/RoleHook";
import Constants from "../../../../../config/constants";

const ProductRewardTable = ({ renderRewardList,updateRewardList }) => {
  const { canUpdate, canCreate} = useRoles(Constants.MODULES.REWARDS_MASTER);
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
    isDialog,
    toggleDialog,
    editData,
  } = useProductRewardTable({ renderRewardList });

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
        </div>
      </div>
    );
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "reward",
        label: "Reward",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.titleCont}>{all?.name}</div>
        ),
      },

      {
        key: "type",
        label: "Type",
        sortable: false,
        render: (temp, all) => <div>{all?.type}</div>,
      },
      {
        key: "sub_type",
        label: "Sub Type",
        sortable: false,
        render: (temp, all) => <div>{removeUnderScore(all?.action)}</div>,
      },
      {
        key: "point",
        label: "Default Points",
        sortable: false,
        render: (temp, all) => <div>{all?.default_points}</div>,
      },
      {
        key: "point",
        label: "Extra Points",
        sortable: false,
        render: (temp, all) => <div>{all?.extra_points ?? 'N/A'}</div>,
      },
      ...(canUpdate? [{
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.listActionContainer}>
            <ListActionComponent
              allData={all}
              handleEdit={toggleDialog}
              key={all?.id}
            />
          </div>
        ),
      },]:[])
    ],
    [renderFirstCell, toggleDialog]
  );

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <div className={styles.mainContainer}>
      {isDialog && (
        <ProductRewardCreate
          isOpen={isDialog}
          handleToggle={toggleDialog}
          editData={editData}
          updateRewardList={updateRewardList}
        />
      )}

      <div className={styles.row1}>
        <Typography
          variant={"h5"}
          className={styles.productHeading}
          color={"text.primary"}
        >
          {" "}
          Reward Details
        </Typography>
        {canCreate &&<ArrowPrimaryButton
          onClick={toggleDialog}
          icon={<Add fontSize="normal" />}
        >
          ASSOCIATE REWARD
        </ArrowPrimaryButton>}
      </div>
      <br />
      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </div>
  );
};

export default ProductRewardTable;
